<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card class="graphDetail2" :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card-dbm-risk dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :series="graph3.series" :xAxis="graph3.xAxis" @change="dateRangeChangeForGraph3">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       class="py-3 px-0 lg:px-8" type="border" @click="dataTypeChangeForGraph3(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </daily-comparison-card-dbm-risk>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCardDbmRisk from "@/views/graph-detail/components/DailyComparisonCardDbmRisk.vue";

export default {
  name: "GraphDetail09",
  components: {
    DailyComparisonCardDbmRisk,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getFieldLabel() {
      return '사업장';
    },
    getButtons() {
      switch (this.getLevel) {
      case 1:
        return [
          {label: '지사', dataType: 'company0'},
          {label: '센터', dataType: 'company1'},
          {label: '회사', dataType: 'company2'},
          { label: this.getFieldLabel, dataType: 'field' },
          // { label: '재해형태', dataType: 'disaster' },
        ];
      case 2:
        return [
          {label: '센터', dataType: 'company0'},
          {label: '회사', dataType: 'company1'},
          { label: this.getFieldLabel, dataType: 'field' },
          // { label: '재해형태', dataType: 'disaster' },
        ];
      case 3:
        return [
          {label: '회사', dataType: 'company0'},
          { label: this.getFieldLabel, dataType: 'field' },
          // { label: '재해형태', dataType: 'disaster' },
        ];
      case 4:
        return [
          { label: this.getFieldLabel, dataType: 'field' },
          // { label: '재해형태', dataType: 'disaster' },
        ];
      }
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  data() {
    return {
      buttons: [
        { label: '부서', dataType: 'company' },
        { label: '사업장', dataType: 'field' },
        // { label: '재해형태', dataType: 'detail' },
      ],
      boardId: 529,
      summaryKey: ["정기위험성평가_재해형태", "sum"],
      graph1: {
        title: "전체 위험성 결정 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 위험성 결정 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "1~2(L)" }, { name: "3~4(ML)" }, { name: "6(M)" }, { name: "8~9(H)" }, { name: "12~16(HH)" }],
        list: [],
        dataType: this.$route.params.proj_id ? "company" : "project",
      },
      graph3: {
        title: "기간별 위험성 결정 현황",
        unit: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        // beginDate: new Date().format("yyyy-MM-dd"),
        // endDate: new Date().format("yyyy-MM-dd"),
        list: [],
        dataType: this.$route.params.proj_id ? "company" : "project",
        series: [],
        xAxis: [],
      },
      cache: {},
    };
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.loadDetailData();

    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;
    this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
  },
  methods: {
    // API에서 상세 정보를 불러온다
    async loadDetailData(currentYear, depth = -1) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (depth < 0) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          depth
        };
        const data = await this.$store.dispatch("summary/LOAD_DONUT_09_DETAIL_DBM", params);
        this.cache[cacheKey] = data;
        // console.log(currentYear, depth, data);
        return data;
      }
    },
    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);
      const graph1Data = data.monthly;
      const currentYear = graph1Data[yyyy] ? graph1Data[yyyy] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const prevYear = graph1Data[yyyy - 1] ? graph1Data[yyyy - 1] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      // 첫번째 배열은 총 합이므로, 데이터에서 제외한다
      currentYear.shift();
      prevYear.shift();

      this.graph1.data1 = currentYear;
      this.graph1.data2 = prevYear;
      this.graph1.sum1 = `${prevYear[prevYear.length - 1]}`;
      this.graph1.sum2 = `${currentYear[currentYear.length - 1]}`;
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      let depth = 1;
      if (this.graph2.dataType === "company2") {
        depth = 2;
      }
      else if (this.graph2.dataType === "company0") {
        depth = 0;
      }
      const data = await this.loadDetailData(yyyy, depth)

      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "field":
        graph2Data = data.field;
        break;
      case "disaster":
        graph2Data = data.disaster;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph2.month;
      // const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      // const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph2Data[currentYear][currentMonth];
      // const prevData = graph2Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        list.push({
          no,
          name: row.label,
          rate_0: (row.rate[0] ? row.rate[0] : 0) === 0 ? '0' : row.rate[0],
          rate_1: (row.rate[1] ? row.rate[1] : 0) === 0 ? '0' : row.rate[1],
          rate_2: (row.rate[2] ? row.rate[2] : 0) === 0 ? '0' : row.rate[2],
          rate_3: (row.rate[3] ? row.rate[3] : 0) === 0 ? '0' : row.rate[3],
          rate_4: (row.rate[4] ? row.rate[4] : 0) === 0 ? '0' : row.rate[4],
        });
        no += 1;
      }

      // list를 rate_4가 많고, rate_3가 많고, rate_2가 많고, rate_1이 많고, rate_0이 많은 순으로 정렬한다
      list.sort((a, b) => {
        const b_rate_0 = Number(b.rate_0);
        const b_rate_1 = Number(b.rate_1);
        const b_rate_2 = Number(b.rate_2);
        const b_rate_3 = Number(b.rate_3);
        const b_rate_4 = Number(b.rate_4);
        const a_rate_0 = Number(a.rate_0);
        const a_rate_1 = Number(a.rate_1);
        const a_rate_2 = Number(a.rate_2);
        const a_rate_3 = Number(a.rate_3);
        const a_rate_4 = Number(a.rate_4);

        if (b_rate_4 !== a_rate_4) return b_rate_4 - a_rate_4;
        if (b_rate_3 !== a_rate_3) return b_rate_3 - a_rate_3;
        if (b_rate_2 !== a_rate_2) return b_rate_2 - a_rate_2;
        if (b_rate_1 !== a_rate_1) return b_rate_1 - a_rate_1;
        if (b_rate_0 !== a_rate_0) return b_rate_0 - a_rate_0;

        return 0;
      });

      this.graph2.list = list;
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.rate_0;
      if (index === 3) return value.rate_1;
      if (index === 4) return value.rate_2;
      if (index === 5) return value.rate_3;
      if (index === 6) return value.rate_4;
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = `${label}`;
      if (this.projectId) {
        this.graph2.dataType = dataType;
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      let depth = 1;
      if (this.graph3.dataType === 'company0') {
        depth = 0;
      } else if (this.graph3.dataType === 'company1') {
        depth = 1;
      } else if (this.graph3.dataType === 'company2') {
        depth = 2;
      }

      const data = await this.loadDetailData(yyyy, depth)
      let graph2Data = [];
      switch (this.graph3.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "field":
        graph2Data = data.field;
        break;
      case "disaster":
        graph2Data = data.disaster;
        break;
      default:
        return;
      }

      const currentYear = this.graph3.year;
      const currentMonth = this.graph3.month;
      const currentData = graph2Data[currentYear][currentMonth];

      const seriesData = [
        { name: '1~2(L)', data: []},
        { name: '3~4(ML)', data: []},
        { name: '6(M)', data: []},
        { name: '8~9(H)', data: []},
        { name: '12~16(HH)', data: []},
      ];
      const xAxis = [];

      // monthlyData 항목들을 rate 값의 합으로 내림차순 정렬한다
      currentData.sort((a, b) => {
        const aSum = a.rate.reduce((a, b) => a + b, 0);
        const bSum = b.rate.reduce((a, b) => a + b, 0);
        return bSum - aSum;
      });

      for (const item of currentData) {
        const label = item.label;
        const rate = item.rate;

        xAxis.push(label);
        for (let i = 0; i < rate.length; i++) {
          seriesData[i].data.push(rate[i]);
        }
      }

      this.graph3.series = seriesData;
      this.graph3.xAxis = xAxis;
    },
    dateRangeChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      // this.graph3.beginDate = beginDate;
      // this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType, /*label*/) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },
  },
};
</script>

<style scoped></style>
<style>
@media (min-width: 1024px) {
  .graphDetail2 table {
    width: 100% !important;
  }
}

</style>
